package com.karawek.core.auth.model

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.screen.Screen

interface OtpHandle : Screen

@Parcelize
object EmptyOtpHandle: OtpHandle

@Parcelize
data class MockOtpHandle(
    val token: String,
    val channel: OtpChannel,
    val destination: String,
) : OtpHandle
